import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ApiService } from '../_services/api.service';
import { ChangelogEntry } from '../_models/ChangelogEntry';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit {
  date: number;
  latestVersion = '';
  latestDate = '';

  constructor(private apiService: ApiService) {
    this.date = new Date().getFullYear();
  }

  ngOnInit(): void {
    this.apiService.getLatestChangelog().subscribe({
      next: (latest: ChangelogEntry) => {
        this.latestVersion = latest.version || 'N/A';
        this.latestDate = latest.date ? new Date(latest.date).toLocaleDateString() : '';
      },
      error: (err) => {
        this.latestVersion = 'N/A';
        this.latestDate = '';
      }
    });
  }
}
